import util from '../util'

let controller = 'ParceiroOperacaoComissao'
export default Object.assign({}, util.GetCrud(controller, null))
